module.exports = __webpack_public_path__ + "bb6539d00703cb27be4f90d18a60f41c.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/age-gate-bg-1080.webp
// module id = 165
// module chunks = 0